export enum ProductIdentification {
  ACCIDENT = 'ACCIDENT',
  BAGGAGE = 'BAGGAGE',
  CANCELLATION_CLAIM_AMOUNT_1K = 'CANCELLATION_CLAIM_AMOUNT_1K',
  CANCELLATION_CLAIM_AMOUNT_2_5K = 'CANCELLATION_CLAIM_AMOUNT_2_5K',
  CANCELLATION_CLAIM_AMOUNT_5K = 'CANCELLATION_CLAIM_AMOUNT_5K',
  TRAVEL = 'TRAVEL',
}
